<template>
  <div class="MyTicket">
    <main v-show="formShow">
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6 offset-md-3">
              <div class="page-header-content">
                <h1 class="page-header-title">
                  <div class="page-header-icon">
                    <i data-feather="activity"></i>
                  </div>
                  <span>My Tickets</span>
                </h1>
                <!--  <div class="page-header-subtitle">Support Ticketing Reports</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid mt-n10">
        <div class="row">
          <div class="col-md-6 offset-md-3">
            <transition name="custom-classes-transition" enter-active-class="animated bounceInLeft" leave-active-class="animated bounceOutRight">
              <div class="card bg-light" v-show="animate">
                <div class="card-body">
                  <h5>Please provide your email.</h5>
                  <p>The system will list out your tickets.</p>

                  <form @submit="handleSubmit">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <input type="text" v-model="email" class="form-control form-control-lg" placeholder="e.g. john@gmail.com" :class="{ 'is-invalid': $v.email.$error, 'is-valid': !$v.email.$invalid}" />
                          <div class="invalid-feedback">
                            <span v-if="!$v.email.required">Email is required.</span>
                            <span v-if="!$v.email.email">Email must be valid email address.</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <button class="btn btn-danger btn-lg" type="submit" id="submitButton__" disabled__="disabled__">
                      <i class="far fa-paper-plane mr-1"></i>
                      Send
                    </button>
                  </form>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </main>

    <main v-show="!formShow">
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>My Tickets</span>
            </h1>
            <!--  <div class="page-header-subtitle">Support Ticketing Reports</div> -->
          </div>
        </div>
      </div>
      <div class="container mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <!-- <div class="card-header">DataTable Example</div> -->
              <div class="card-body">
                <vue-good-table
                  :columns="columns"
                  :rows="tickets"
                  :search-options="{
                    enabled: true,
                    trigger: 'enter',
                  }"
                  :pagination-options="{
                    enabled: true,
                    perPage: 20,
                  }"
                  styleClass="vgt-table condensed myGoodTable"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'ref'">
                      <router-link :to="{name: 'TicketDetails', params: {ref: props.row.ref}}">
                        <b>{{props.row.ref}}</b>
                      </router-link>
                    </span>
                    <span v-if="props.column.field == 'status'">
                      <span v-if="props.row.status.slug == 'open'" class="badge badge-danger">{{props.row.status.name}}</span>
                      <span v-else-if="props.row.status.slug == 'closed'" class="badge badge-success">{{props.row.status.name}}</span>
                      <span v-else-if="props.row.status.slug == 'escalated'" class="badge badge-warning">{{props.row.status.name}}</span>
                    </span>
                    <span v-if="props.column.field == 'categoryName'">{{props.row.category.name}}</span>
                    <span v-if="props.column.field == 'subcategoryName'">{{props.row.subCategory.name}}</span>
                    <span v-if="props.column.field == 'title'">{{props.row.title}}</span>
                    <!-- <span v-if="props.column.field == 'userName'">{{props.row.user.name}}</span> -->
                    <span v-if="props.column.field == 'agentName'">{{props.row.agent.name}}</span>
                    <span v-if="props.column.field == 'createdAt'">{{props.row.createdAt | formatDateTime}}</span>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "MyTicket",

  data() {
    return {
      animate: false,
      formShow: true,
      email: "",
      tickets: [],
    };
  },

  mounted() {
    this.animate = true;
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault();
      let loading = this.$loading.show();
      this.$v.$touch();
      if (this.$v.$invalid) {
        loading.hide();
        return;
      }
      // others
      axios
        .get("/tickets", {
          params: {
            email: this.email,
          },
        })
        .then((res) => {
          if (res.data.status == "success") {
            this.formShow = false;
            this.tickets = res.data.tickets;
          } else {
            this.$swal("Oops!", res.data.message, "error");
          }
          loading.hide();
        });
    },
  },

  computed: {
    columns() {
      let cols = [
        {
          label: "ReferenceID",
          field: "ref",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: this.client.topCategoryLabel,
          field: "categoryName",
        },
        {
          label: this.client.subCategoryLabel,
          field: "subcategoryName",
        },
        {
          label: "Subject",
          field: "title",
        },
        /* {
          label: "CreatedBy",
          field: "userName",
        }, */
        {
          label: "AssignedTo",
          field: "agentName",
        },
        {
          label: "Data/Time",
          field: "createdAt",
        },
      ];
      return cols;
    },

    client() {
      return this.$store.state.client;
    },
  },

  validations: {
    email: { required, email },
  },
};
</script>
